module.exports = __webpack_public_path__ + "static/fipcpurplefloralrab3-c2dc8e66b9da7b0d92b0b288e65d377c.jpeg";